import { styled, css } from 'styled-components';

import { ArrowRight } from '@src/components/atoms/icons/arrow-right';
import { Action } from 'src/components/atoms/action';
import { ActionList } from 'src/components/atoms/action-list';

export const Heading = styled.h4<{ $isStrikeThrough?: boolean }>`
  ${({ $isStrikeThrough }) =>
    $isStrikeThrough &&
    css`
      text-decoration: line-through;
    `}
`;

export const TripDetailHeaderWrapper = styled.div`
  --spacing-inline: 16px;

  display: grid;
  grid-template-rows: 118px 1fr;
  border: 1px solid #dedddb;
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  background-color: white;
  overflow: hidden;

  > div:first-child {
    border-radius: 24px 24px 0 0;
  }

  > div:last-child,
  ${ActionList}:last-child li:last-child ${Action} {
    border-radius: 0 0 24px 24px;
  }

  @media screen and (min-width: 1024px) {
    --spacing-inline: 24px;

    grid-template-rows: unset;
    grid-template-columns: 1fr 1fr;

    > div:first-child {
      border-radius: 24px 0 0 24px;
    }

    > div:last-child {
      border-radius: unset;
    }

    ${ActionList}:last-child li:last-child ${Action} {
      border-radius: 0 0 24px 0;
    }
  }
`;

export const TripDetailHeaderContent = styled.div``;

export const TripMainInfo = styled.div`
  display: grid;
  row-gap: 4px;
  padding-bottom: 8px;
  padding-top: 24px;
  padding-inline: var(--spacing-inline);

  @media screen and (min-width: 1024px) {
    padding-bottom: 16px;
  }
`;

export const Dates = styled.div`
  --line-height-dates: 26px;

  display: flex;
  gap: 8px;
  align-items: flex-start;

  > * {
    flex: 1 0 auto;
  }

  @media screen and (min-width: 1024px) {
    --line-height-dates: 40px;

    gap: 16px;
  }
`;

export const DatesArrowRight = styled(ArrowRight)`
  --arrow-size: 24px;

  flex: 0 0 auto;
  width: var(--arrow-size);
  height: var(--arrow-size);
  margin-block: calc((var(--line-height-dates) - var(--arrow-size)) / 2);
  color: var(--color-numa-black--250);
`;

export const DateWrapper = styled.div<{ $textAlign: 'start' | 'end' }>`
  display: grid;
  gap: 4px;
  text-align: ${({ $textAlign }) => $textAlign};
  justify-items: ${({ $textAlign }) => $textAlign};

  h4 {
    font-family: var(--font-lausanne);
    font-size: var(--font-size-body);
    line-height: 130%;
    color: var(--color-numa-black--400);
  }

  p {
    margin: 0;
    font-family: var(--font-lausanne);
    font-size: var(--font-size-label);
    color: var(--color-neutral-subdued);
    line-height: 130%;
  }
`;

export const ExtensionText = styled.span`
  display: none;

  &:after {
    content: '\\00a0';
  }

  @media screen and (min-width: 375px) {
    display: inline-block;
  }
`;
